import React from "react"
import { graphql } from 'gatsby'
import './_md_block.scss'

const MdBlock = ({ content }) => {
    return (
    	<div className="md-block">
    		<div
    		className="markdown-body" dangerouslySetInnerHTML={{ __html: content }} />
    	</div>
    );
};

export default MdBlock;
